import React, { Component } from "react";
import Layout from "./../layouts/Index";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import BlockLoader from "./../contentloaders/BlockLoader";
import {
  Row,
  Col,
  Container,
  Table,
  Button,
  Form,
  Modal,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import {
  getTransactions,
  createPoints,
  getMoreTransactions,
  searchTransactions,
  searchedTransactions,
} from "./../../store/actions/TransactionActions";
import { createSchema } from "./../../helpers/validation/transaction";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { FaSearch } from "react-icons/fa";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,

      editModal: false,

      supplier: {},

      loading: false,

      trx_search_term: "",
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });

    const res = await this.props.getTransactions();

    if (res) {
      this.setState({ loading: false });
    }
  };

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  createPoints = async (values) => {
    try {
      // console.log(values);

      this.setState({ loading: true });

      const result = await this.props.createPoints(values);

      if (result) {
        // console.log(result);

        toast.success("Points Created Successfully !", {
          position: "bottom-center",
        });

        this.setState({ showModal: false, loading: false });

        await this.props.getTransactions();
      }
    } catch (error) {
      console.log(error);

      this.setState({ loading: false });

      if (error.response.data !== undefined) {
        toast.error(error.response.data.message, {
          position: "bottom-center",
        });
      }
    }
  };

  fetchMoreTransactions = async () => {
    try {
      this.setState({ loading: true });

      const {
        transactions: { next_page },
      } = this.props;

      const result = await this.props.getMoreTransactions(next_page);

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
    }
  };

  searchTransactions = async () => {
    this.setState({ loading: true });
    try {
      const { trx_search_term } = this.state;

      let obj = {};

      if (trx_search_term !== "") {
        obj.trx_search_term = trx_search_term;
      }

      const result = await this.props.searchTransactions(obj);

      if (result.length === 0) {
        return toast.warning("Transactions Not Found!", {
          position: "bottom-center",
          autoClose: 1000,
        });
      }

      const searchedTransactionsResults = await this.props.searchedTransactions(result);

      if (searchedTransactionsResults.length > 0) {
        toast.success("Transactions Found!", {
          autoClose: 1500,
          position: "bottom-center",
        });
      } else {
        toast.warning("Transactions Not Found!", {
          position: "bottom-center",
        });
      }
    } catch (error) {
        if (error.response !== undefined && error.response.status === 404) {
          toast.warning("Transactions Not Found!", {
            position: "bottom-center",
          });
        }
      } finally {
        this.setState({ loading: false });
      }
  };

  keyPress = async (e) => {
    try {
      if (e.keyCode === 13) {
        await this.searchTransactions();
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  refresh = async () => {
    this.setState({ loading: true });

    const result = await this.props.getTransactions();

    if (result) {
      this.setState({
        loading: false,
        name: "",
        trx_search_term: "",
      });
    }
  };

  render() {
    const {
      transactions,
      transactions: { page, pages },
    } = this.props;

    const { loading, trx_search_term } = this.state;

    return (
      <Layout>
      <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
        <Container>
        <Row>
          <Col xs="12" md="6" lg="4" className="mb-3 mx-auto">
            <Form
              onSubmit={async (e) => {
                e.preventDefault();
                if (!trx_search_term?.trim()) return; // must have at least one
                await this.searchTransactions();
              }}
            >
              <InputGroup className="search-input-group">
                <FormControl
                  type="text"
                  placeholder="Search Account No./Reference/Phone"
                  name="trx_search_term"
                  value={this.state.trx_search_term || ""}
                  onKeyDown={this.keyPress}
                  onChange={this.handleChange}
                  className="rounded-pill shadow-sm"
                />
                {/* Clear Button (X) */}
                {(this.state.trx_search_term?.trim()) && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.setState({ trx_search_term: "" }, () => {
                        this.refresh();
                      });
                    }}
                    className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                    style={{
                      width: "40px",
                      height: "40px",
                      padding: 0,
                    }}
                  >
                    ×
                  </Button>
                )}
                {/* Search Button */}
                <Button
                  variant="success"
                  type="submit"
                  disabled={
                    !this.state.trx_search_term?.trim()
                  }
                  className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                  style={{
                    width: "40px",
                    height: "40px",
                    padding: 0,
                  }}
                >
                  <FaSearch size={16} />
                </Button>
                </InputGroup>
            </Form>
          </Col>

              <Col
              sm="12"
              style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "1em",
              }}
              >
              <h3 className="mb-0">Transactions</h3>

              <Button
              variant="success"
              size="sm"
              onClick={() => this.toggleModal()}
              >
              Redeem Points
              </Button>
              </Col>

              <Col sm="12">
              {!loading && (
              <div style={{ overflowX: "auto" }}>
                <Table
                    striped
                    bordered
                    hover
                    size="lg"
                    variant="light"
                    responsive="sm"
                    className="transactions-table"
                  >
                <thead>
                  <tr>
                  <th>#</th>
                  <th>Account Number</th>
                  <th>Amount (KES)</th>
                  <th>Reference</th>
                  <th>Type</th>
                  <th>Name(s)</th>
                  <th>Phone number</th>
                  <th>Transaction Date</th>
                  <th>Status</th>
                  <th></th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.data.map((transaction, i) => (
                  <tr key={i}>
                  <td data-label="#">{i + 1}</td>
                  <td data-label="Account Number">
                    {transaction.bid_id !== undefined ? (
                        <Link to={`/admin/bids/${transaction.bid_id}`}>{transaction.account_number}</Link>
                    ):(
                        transaction.account_number
                    )}
                  </td>
                  <td data-label="Amount (KES)">{transaction.amount}</td>
                  <td data-label="Reference">{transaction.reference}</td>
                  <td data-label="Type">{transaction.type}</td>
                  <td data-label="Sender Name(s)">{transaction.user}</td>
                  <td data-label="Phone number"><Link to={`/admin/users/${transaction.user_id}`}>{transaction.sender}</Link></td>
                  <td data-label="Transaction Date">
                  <Moment format="DD/MM/YYYY HH:mm:ss">
                    {transaction.date_created}
                  </Moment>
                  </td>
                  <td data-label="Status">
                  {transaction.status === 1
                    ? "Received"
                    : "Not Received"}
                  </td>
                  <td data-label=" ">
                  <Button
                    variant="info"
                    style={{ color: "#fff" }}
                    type="submit"
                    as={Link}
                    to={`/admin/transactions/${transaction.id}`}
                  >
                    View
                  </Button>
                  </td>
                  </tr>
                  ))}
                </tbody>
                </Table>
              </div>
              )}
              </Col>

              <Col sm="12">
              {loading && (
              <BlockLoader
              width="100%"
              height="400px"
              innerWidth="100%"
              innerHeight="100%"
              />
              )}
              </Col>

              {page < pages && (
              <Col
              sm="12"
              style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "2em",
              }}
              >
              <Button
              variant="primary"
              size="lg"
              onClick={() => this.fetchMoreTransactions()}
              disabled={loading}
              >
              {loading === true ? "Loading ..." : "Load More"}
              </Button>
              </Col>
              )}
            </Row>
            </Container>
            </Col>
            <style>{`
              @media (max-width: 767px) {
                .transactions-table thead {
                  display: none;
                }
                .transactions-table, .transactions-table tbody, .transactions-table tr, .transactions-table td {
                  display: block;
                  width: 100%;
                }
                .transactions-table tr {
                  margin-bottom: 1rem;
                  border-bottom: 2px solid #dee2e6;
                }
                .transactions-table td {
                  text-align: right;
                  padding-left: 50%;
                  position: relative;
                  border: none;
                  border-bottom: 1px solid #dee2e6;
                }
                .transactions-table td:before {
                  content: attr(data-label);
                  position: absolute;
                  left: 0;
                  width: 50%;
                  padding-left: 1rem;
                  font-weight: bold;
                  text-align: left;
                  white-space: nowrap;
                }
              }`
              }</style>

            {/* New Points */}
      <Modal show={this.state.showModal} onHide={this.toggleModal}>
        <Modal.Header closeButton>
        <Modal.Title>Redeem Points</Modal.Title>
        </Modal.Header>

        <Formik
        initialValues={{ points: "", amount: "", msisdn: "" }}
        validationSchema={createSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          this.createPoints(values);
        }}
        >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <div>
          <Modal.Body>
            <Form>
            <Form.Group as={Row} controlId="points" className="mb-3">
              <Form.Label column xs={12} sm={3}>
              Points
              </Form.Label>
              <Col xs={12} sm={9}>
              <Form.Control
                type="number"
                placeholder="Points"
                name="points"
                isValid={touched.points && !errors.points}
                isInvalid={errors.points && touched.points}
                value={values.points}
                onChange={handleChange}
              />
              {errors.points && touched.points && (
                <Form.Control.Feedback type="invalid">
                {errors.points}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="amount" className="mb-3">
              <Form.Label column xs={12} sm={3}>
              Transaction Amount
              </Form.Label>
              <Col xs={12} sm={9}>
              <Form.Control
                type="number"
                placeholder="Amount"
                name="amount"
                isValid={touched.amount && !errors.amount}
                isInvalid={errors.amount && touched.amount}
                value={values.amount}
                onChange={handleChange}
              />
              {errors.amount && touched.amount && (
                <Form.Control.Feedback type="invalid">
                {errors.amount}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="msisdn" className="mb-3">
              <Form.Label column xs={12} sm={3}>
              Phone Number
              </Form.Label>
              <Col xs={12} sm={9}>
              <Form.Control
                type="text"
                placeholder="Phone Number"
                name="msisdn"
                isValid={touched.msisdn && !errors.msisdn}
                isInvalid={errors.msisdn && touched.msisdn}
                value={values.msisdn}
                onChange={handleChange}
              />
              {errors.msisdn && touched.msisdn && (
                <Form.Control.Feedback type="invalid">
                {errors.msisdn}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal}>
            Close
            </Button>

            <Button
            variant="success"
            onClick={handleSubmit}
            disabled={loading}
            >
            Redeem Points
            </Button>
          </Modal.Footer>
          </div>
        )}
        </Formik>
      </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    transactions: state.transactions,
  };
};

export default connect(mapStateToProps, {
  getTransactions,
  createPoints,
  getMoreTransactions,
  searchTransactions,
  searchedTransactions,
})(Index);
